import { render, staticRenderFns } from "./RequisitionDocuments.vue?vue&type=template&id=0f680554&"
import script from "./RequisitionDocuments.vue?vue&type=script&lang=js&"
export * from "./RequisitionDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports